import { base64ToBytes } from './utils.js';
const TOKEN_INSTRUCTIONS = {
    0: 'InitializeMint',
    1: 'InitializeAccount',
    2: 'InitializeMultisig',
    3: 'Transfer',
    4: 'Approve',
    5: 'Revoke',
    6: 'SetAuthority',
    7: 'MintTo',
    8: 'Burn',
    9: 'CloseAccount',
    10: 'FreezeAccount',
    11: 'ThawAccount',
    12: 'TransferChecked',
    13: 'ApproveChecked',
    14: 'MintToChecked',
    15: 'BurnChecked',
    16: 'InitializeAccount2',
    17: 'SyncNative',
    18: 'InitializeAccount3',
    19: 'InitializeMultisig2',
    20: 'InitializeMint2',
    21: 'GetAccountDataSize',
    22: 'InitializeImmutableOwner',
    23: 'AmountToUiAmount',
    24: 'UiAmountToAmount',
};
const TOKEN_PROGRAM_IDS = new Set([
    'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA',
    'TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb',
]);
export const decodeTokenInstruction = (ix) => {
    if (!TOKEN_PROGRAM_IDS.has(ix.programId))
        return undefined;
    if (!ix.data)
        return { name: 'Token Instruction' };
    try {
        const buf = base64ToBytes(ix.data);
        const type = buf[0];
        const name = TOKEN_INSTRUCTIONS[type] ?? `Unknown (${type})`;
        return { name, args: { type } };
    }
    catch {
        return { name: 'Token Instruction' };
    }
};
//# sourceMappingURL=token.js.map